// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const ColumnPickerSlice = createSlice({
  name: 'columnPicker',
  initialState: {
    columnPicker: [],
    showColumnPicker: false
  },
  reducers: {
    setColumnPicker(state, { payload }) {
      state.columnPicker = payload;
    },
    setShowColumnPicker(state, action) {
      state.showColumnPicker = action.payload;
    },
    resetColumnPicker(state) {
      state.columnPicker = [];
      state.showColumnPicker = false;
    }
  }
});

const { actions, reducer } = ColumnPickerSlice;
export const { setColumnPicker, setShowColumnPicker, resetColumnPicker } = actions;

export default reducer;
